type LoadingScreenProps = {
  type?: 'primary' | 'secondary';
  text?: string;
};

export default function LoadingScreen({ type = 'primary', text }: LoadingScreenProps) {
  let displayText = text ?? 'Carregando...';

  if (type === 'primary') {
    return (
      <div className="flex flex-col items-center justify-center min-h-[calc(100vh-72px)] bg-linear-to-br from-bg-secondary to-white">
        <div className="mb-2">
          <div className="w-16 h-16 rounded-2xl bg-linear-to-br from-bg-core to-bg-core-dark flex items-center justify-center shadow-lg">
            <div className="w-8 h-8 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        </div>

        <p className="text-text-secondary text-sm font-medium tracking-wide">{displayText}</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-72px)] bg-[#0A141A] bg-[radial-gradient(circle_at_center,rgba(16,57,40,0.35)_0%,rgba(10,20,24,1)_70%)]">
      <div className="mb-2">
        <div className="w-8 h-8 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
      </div>

      <p className="text-text-tertiary text-sm font-medium tracking-wide">{displayText}</p>
    </div>
  );
}
